import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  const highlights = [
    { icon: 'ri-award-line', title: t('about_h1_title'), desc: t('about_h1_desc') },
    { icon: 'ri-team-line', title: t('about_h2_title'), desc: t('about_h2_desc') },
    { icon: 'ri-layout-3-line', title: t('about_h3_title'), desc: t('about_h3_desc') },
    { icon: 'ri-file-list-3-line', title: t('about_h4_title'), desc: t('about_h4_desc') },
  ];

  return (
    <section className="pt-24 pb-10 bg-[#F8F9FA]" id="about">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image + badge */}
          <div className="relative">
            <div className="w-full h-[480px] rounded-lg overflow-hidden">
              <img
                src="https://www.can-el.com/images/about/about.jpg"
                onError={(e) => {
                  (e.target as HTMLImageElement).src = 'https://readdy.ai/api/search-image?query=professional%20electrical%20engineers%20team%20working%20on%20industrial%20project%20site%20Turkey%20construction%20management%20meeting&width=700&height=480&seq=about1&orientation=landscape';
                }}
                alt="About Canel Elektrik"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-[#1A2332] text-white rounded-lg p-6 w-44 text-center">
              <div className="text-4xl font-black text-[#E8A020]">30+</div>
              <div className="text-xs text-white/70 mt-1 leading-tight">{t('stats_years')}</div>
            </div>
            {/* Est badge */}
            <div className="absolute top-6 -left-6 bg-[#E8A020] text-white rounded-lg px-4 py-3 text-xs font-bold leading-tight">
              <div>Est. 1996</div>
              <div className="text-white/80 font-normal">Istanbul, Turkey</div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <span className="text-[#E8A020] text-xs font-bold tracking-widest uppercase">{t('about_label')}</span>
            <h2 className="text-3xl md:text-4xl font-black text-[#1A2332] mt-3 mb-6 leading-tight">
              {t('about_title')}
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              {t('about_p1')}
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              {t('about_p2')}
            </p>

            {/* Highlights */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {highlights.map((h) => (
                <div key={h.title} className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#E8A020]/10 rounded-lg flex-shrink-0 mt-0.5">
                    <i className={`${h.icon} text-[#E8A020] text-lg`} />
                  </div>
                  <div>
                    <div className="font-bold text-[#1A2332] text-sm">{h.title}</div>
                    <div className="text-gray-400 text-xs leading-relaxed">{h.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="/about"
              className="inline-flex items-center gap-2 bg-[#1A2332] text-white font-bold px-7 py-3.5 rounded-full hover:bg-[#E8A020] transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('about_cta')} <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>


      </div>
    </section>
  );
}
